import { Page } from '@/types'
import { AxiosInstance } from 'axios'
import axiosInstance from '.'

export interface AddressUnit {
  address: string
  addressComplement1?: string
  addressComplement2?: string
  zip: string
  town: string
  country: string // iso code country
}

export interface PlaceToVisitRequest {
  // type: UserType
  name: string
  fullName: string
  // firstname: string
  // businessReason: string
  address: AddressUnit
  phonenumber: string
  email: string
}

export interface PlaceToVisitDto {
  id: number

  // type: UserType
  name: string
  fullName: string
  // firstname: string
  // businessReason: string
  address: AddressUnit
  phonenumber: string
  email: string

  createdTime: string
  updatedTime:string
}

class PlaceToVisitApi {
  private axios: AxiosInstance

  public constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public async getAllPlacesToVisit(params: any): Promise<Page<PlaceToVisitDto>> {
    const axiosResponse = await this.axios.get('/place-to-visit', { params })
    return axiosResponse.data
  }

  public create(request: PlaceToVisitRequest): Promise<PlaceToVisitDto> {
    return this.axios.post('/place-to-visit', request).then(it => it.data)
  }

  public update(id: number, request: PlaceToVisitRequest) {
    return this.axios.put(`/place-to-visit/${id}`, request)
  }
}

export const placeToVisitApi = new PlaceToVisitApi(axiosInstance)
